import styled from 'styled-components';

export const TitleFileCreateAgency = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 0.625rem;
  div:nth-child(1) {
    font-size: 1.375rem;
    margin-right: 1rem;
    white-space: nowrap;
  }
  div:nth-child(2) {
    width: 100%;
    height: 1px;
    background-color: #707070;
  }
`;
export const FileItemAgency = styled.div`
  width: 18.75rem;
  height: 2.5rem;
  background-color: #dddddd;
  display: flex;
  align-items: center;
  padding-left: 1.25rem;
  margin-left: 4rem;
  border-radius: 2rem;
  font-size: 1.25rem;
`;
